import Column from "../../../common/components/Column"
import AdminPageHeader from "../components/AdminPageHeader"
import ZohoOrgConnectionPanel from "../components/ZohoOrgConnectionPanel"

export default function AdminZohoMailOrg() {
  return (
    <Column gap={2}>
      <AdminPageHeader
        title="Zoho Mail org connections"
        subtitle="Org-level Zoho Mail Admin OAuth connection (provisioning plane)."
      />
      <ZohoOrgConnectionPanel />
    </Column>
  )
}
